import axios from 'axios';
import errorHandlerFactory from './errorHandler';

const fetchError = errorHandlerFactory('An error occured when fetching monitoring csas.');
const createError = enableTosend => (enableTosend
    ? errorHandlerFactory('An error occured when adding to Acadiasoft')
    : errorHandlerFactory('An error occured when removing csa from Acadiasoft'));

export const getCsas = () => axios.get('/CsaMonitor/MonitoringCsas')
    .then(r => r.data).catch(fetchError);

export const addCsaToAcadiaSoft = data => axios.post('/CsaMonitor/AddAcadiasoftMonitoringCsa', data)
    .then(r => r.data).catch(createError);

export const editCsaInAcadiasoft = data => axios.post('/CsaMonitor/EditAcadiasoftMonitoringCsa', data)
    .then(r => r.data).catch(createError(data.enableToSend));
